<template>
  <!-- 微信支付 -->
  <div class="pay">
    <div class="title">问问风湿患者平台</div>
    <div class="price">¥ {{ price }}</div>
    <div class="spline"></div>
    <div class="info">
      <div>收款方：</div>
      <div>问问风湿</div>
    </div>
    <div class="info">
      <div>项目：</div>
      <div>{{ type | payText }}</div>
    </div>
    <div class="button" @click="confirmPay">确认付款</div>
  </div>
</template>

<script>
/* eslint-disable */
import { Toast as VanToast } from 'vant';
import wx from 'weixin-js-sdk';
import axios from '../services/axios'; // 引用接口调用的  使用方式为 axios.post('url', params).then( res => {}) res为接口的返回

export default {
  name: 'AddressDetail',
  data() {
    return {
      order_code: '', // 医生服务咨询
      price: '', // 支付价格
      orderNum: '', // 处方预约订单
      type: null, // 1: 服务单 2: 预约单
      modeofConsultation: ''
    };
  },
  filters: {
    payText(type) {
      switch (+type) {
        case 1:
          return '图文咨询';
        case 2:
          return '药品支付';
        case 3:
          return '视频问诊';
        case 4:
          return '电话问诊';
        case 5:
          return '暖心赠送';
           case 6:
          return '问问严选';
        default:
          break;
      }
    }
  },
  mounted() {
    // 页面初始时，根据this.$route.query中的参数判断时服务咨询还是处方订单支付
    let { order_code, modeofConsultation, orderNum, giftCode } = this.$route.query;
    this.price = this.$route.query.price; // 获取订单价格

    if (order_code) {
      let obj = { 1: 1, 2: 3, 3: 4 , 4:6 };
      this.order_code = order_code;
      this.type = obj[modeofConsultation];
    } else if (orderNum) {
      this.type = 2;
      this.orderNum = orderNum;
    } else if (giftCode) {
      this.type = 5;
    }
  },
  methods: {
    queryParams() {
      let params = {};
      if (this.type == 1 || this.type == 3 || this.type == 4 ||this.type == 6) {
        // 服务咨询订单
        params.order_code = this.$route.query.order_code;
      } else if (this.type == 2) {
        // 购药订单
        params.orderNum = this.$route.query.orderNum;
      } else if (this.type == 5) {
        // 礼物单号
        params.orderThankId = this.$route.query.giftCode;
        params.money = this.$route.query.price
      }

      const patientParams = JSON.parse(window.localStorage.getItem('patientParams'));
      if (patientParams) {
        params = Object.assign(params, patientParams);
      }

      return params;
    },
    confirmPay() {
      axios.post('/onlineDrug/recipeOrder/pay', this.queryParams()).then(res => {
        if (res.data.status && res.data.status === 'success') {
          const pay_params = res.data.data;
          if (typeof WeixinJSBridge === 'undefined') {
            if (document.addEventListener) {
              document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
            } else if (document.attachEvent) {
              document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
              document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
            }
            window.localStorage.clear('patientInfo');
            window.localStorage.clear('patientParams');
          } else {
            this.onBridgeReady(pay_params);
          }
        } else {
          VanToast.success('微信支付调起失败！');
        }
      });
    },
    onBridgeReady(params) {
      var that = this;
      console.log('============' + this.params);
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: params.appId, //公众号名称，由商户传入
          timeStamp: params.timeStamp, //支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: params.nonceStr, //支付签名随机串，不长于 32 位
          package: params.package, //统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: 'MD5', //签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: params.paySign //支付签名
        },
        function(res) {
         
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
             VanToast.success('支付成功！');
            // if (that.type == 5) {
            // //   that.$router.replace({
            // //     name: '/pennantList',
            // //     query: { doctorId: this.$route.query.doctorId }
            // //   });
            // }
            wx.closeWindow(); // 如果type = 1 关闭页面的方法 回到公众号
          } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
            VanToast.success('支付失败！');
          }
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.pay {
  margin: 0 15px;
  display: flex;
  flex-direction: column;
  text-align: center;
  .title {
    margin-top: 30px;
    font-size: 26px;
  }
  .price {
    margin-top: 10px;
    font-size: 22px;
  }
  .spline {
    margin: 10px 0;
    background: #f5f5f5;
    height: 2px;
  }
  .info {
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
  }
  .button {
    margin: 20px 0;
    width: 100%;
    height: 40px;
    background: #208fe3;
    color: #ffffff;
    font-size: 22px;
    line-height: 40px;
    text-align: center;
  }
}
</style>
